<template>
  <footer class="footer">
      <div class="container position-relative">
        <div class="row">
          <div class="col-lg-2">
              <div class="footer__btn">
                <a href="javascript:void(0);" id="goToTop" class="footer__link" @click="scrollToTop">
                  <div class="footer__icon">
                    <i class="fal fa-long-arrow-up"></i>
                  </div>
                </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2">
            <div class="footer__logo">
              <a :href="localePath('home')">
                <img
                  src="/static/images/default/logo-mbk-white.svg"
                  alt="mbk-logo"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-10">
            <div class="footer__menu">
                <LayoutsMenusFooter />
            </div>

            <div class="row">
                <div class="col-md-6">
                  <div class="footer__address">
                    <div class="footer__title">{{ translate("address.detail01") }}</div> 
                    <span v-html="translate('address.detail02')"></span><br />
                    <span v-html="translate('address.detail03')"></span><br />
                    {{ translate("tel") }} {{ translate("tel.number") }}<br />
                    {{ translate("tel.oversea") }} {{ translate("tel.oversea.number") }}<br />
                    {{ translate("fax") }} {{ translate("fax.number") }}
                  </div>

                </div>
                <div class="col-md-6">
                  <div class="footer__email">
                    <div class="footer__text">{{ translate("email.alerts") }}</div>
                      
                        <div class="footer__wrapper">
                          <div v-html="translate('email.text')"></div>
                          
                          <NuxtLink
                            class="btn btn--link"
                            :to="localePath('/investor-relations/information-inquiry/email-alerts')"
                          >
                            <span class="btn__title">{{
                              translate("subscribe")
                            }}
                            </span>
                              <span class="btn__icon">
                              <i class="far fa-angle-right"></i>
                            </span>
                          </NuxtLink>
                        </div>
                    </div>
                    <!-- <div class="footer__social">
                           <div>{{ translate("share.social") }}</div> 
                           <div class="media media--share">
                              <div class="media-item">
                                  <a class="media-link" :href="`${translate('facebook.link')}`" target="_blank">
                                      <i class="icon-fb"></i>
                                  </a>
                              </div>
                              <div class="media-item">
                                  <a class="media-link" :href="`${translate('x.link')}`" target="_blank">
                                      <i class="icon-twitter"></i>
                                  </a>
                              </div>
                              <div class="media-item">
                                  <a class="media-link" :href="`${translate('line.link')}`" target="_blank">
                                      <i class="icon-line"></i>
                                  </a>
                              </div>
                          </div>
                    </div> -->


                </div>
            </div>

  
          </div>
        </div>
        <div class="row"> 
          <div class="col-12">
            <div class="footer__copyright">
              {{ translate("copyright") }}
              <img src="/static/images/logo-cac.png" loading="lazy" alt="logo-cac">
            </div>
          </div>
        </div>
      </div>
  </footer>
</template>

<script setup>
import { useTranslationStore } from "@/stores/translations";

// ดึง store สำหรับการแปล
const translationStore = useTranslationStore();

// ดึงข้อมูลการแปลเมื่อ component ถูก mount
callOnce(async () => {
  await translationStore.fetchTranslations();
});

// สร้างฟังก์ชันสำหรับการแปล
const translate = translationStore.translate;


const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
  html[lang="#{$lang}"] {
    .footer {
      @include font-size("lead", $lang);

      .footer__title {
        @include font-weight("medium", $lang);
      }


      .footer__email {
        @include font-size("lead", $lang);
        @include font-weight("medium", $lang);
      }

      .footer__copyright {
        @include font-size("lead", $lang);
      }
    }
  }
}

.footer {
  position: relative;
  background-color: $darkgreen;
  color: $white;
  padding: 2.75rem 0;

  @include media-breakpoint-down(md) {
    padding: 2rem 0;
  }

  .footer__btn{
    position: absolute;
    top: -4rem;
    right: 0rem;
    background-color: $white;
    padding: 10px;
    z-index: 3;

    @include media-breakpoint-down(md) {
      top: -3rem;
      right: 1rem;
    }
  }

  .footer__link{
    color: $darkgreen-1;

        @include hover-focus-active {
            color: $green-1;
        }
  }
  
  .footer__icon{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .footer__logo{
    @include media-breakpoint-down(md) {
      text-align: center;
    }
  }

  .footer__address {
    color: $green-1;
  }

  .footer__menu{
    margin-bottom: 1.65rem;

    @include media-breakpoint-down(md) {
      margin-top: 2rem;
    }
  }

  .footer__logo {
    img {
      max-width: 100%;
      height: auto;
    }
  }

  .footer__email {
    @include media-breakpoint-up(lg) {
      display: flex;
    }
    @include media-breakpoint-down(sm) {
      margin: 1.45rem 0 0.45rem;
    }
  }

  .footer__text {
    min-width: max-content;

    @include media-breakpoint-up(lg) {
      padding-right: 1rem;
    }
  }


  .footer__copyright {
    margin-top: 1.75rem;
    text-align: center;

    img{
      padding-left: 10px;
    }
  }

  .footer__social{
    display: flex;
    margin-top: 1rem;
    align-items: baseline;
  }
}


.btn {
  &.btn--link {
    margin-top: 1rem;
  }

}
</style>
